(() => {
  const states = new Map();
  let frameId = 0;

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function getState(flow) {
    const key = `${flow.dataset.productId}:${flow.dataset.formId}`;
    if (!states.has(key)) states.set(key, { mode: 'now', pending: false });
    return states.get(key);
  }

  function getConfig(flow) {
    try { return JSON.parse(flow.querySelector('[data-bmp-order-config]').textContent); }
    catch { return {}; }
  }

  function propertyInput(form, name) {
    return Array.from(form?.elements || []).find((input) => input.name === `properties[${name}]` && input.value);
  }

  function uploadState(flow, state) {
    const form = document.getElementById(flow.dataset.formId);
    const file = state.container?.querySelector('form[data-uploadery] input[type="file"]');
    const busy = !!state.container?.querySelector('.uploadery-temporary, .uploaderyIsUploading');
    if (state.pending && !file?.files?.length && !busy) state.pending = false;
    return { file, pending: state.pending || busy, uploaded: propertyInput(form, 'File')?.value || '' };
  }

  function wishesState(flow, state) {
    const select = state.container?.querySelector('select[name="properties[Personalisering]"]');
    const required = flow.dataset.personal !== 'true' && select?.value === 'JA';
    const field = Array.from(state.container?.querySelectorAll('textarea') || []).find((input) =>
      [input.name, input.getAttribute('name-disabled')].includes('properties[Instruction]')
    );
    const missing = required && !field?.value.trim();
    const ready = !required || (field && !field.disabled && field.name === 'properties[Instruction]' && field.form === document.getElementById(flow.dataset.formId));
    if (field) {
      field.required = required;
      field.setAttribute('aria-required', String(required));
      field.setCustomValidity(missing ? getConfig(flow).wishes_required_error : '');
      if (!missing) field.removeAttribute('aria-invalid');
    }
    return { field, required, missing, ready };
  }

  function labelField(container, name, label, placeholder, rows) {
    const field = Array.from(container.querySelectorAll('textarea')).find((input) =>
      [input.name, input.getAttribute('name-disabled')].includes(`properties[${name}]`)
    );
    if (!field) return;
    const row = field.closest('div');
    row?.classList.add('bmp-order-field');
    const fieldLabel = Array.from(row?.querySelectorAll('label') || []).find((node) => node.htmlFor === field.id) || row?.querySelector('label');
    if (fieldLabel && !fieldLabel.contains(field)) setText(fieldLabel, label);
    if (field.placeholder !== placeholder) field.placeholder = placeholder;
    if (field.rows !== rows) field.rows = rows;
  }

  function enhance(flow, state) {
    const container = state.container;
    const config = getConfig(flow);
    flow.hidden = false;
    for (const field of container.querySelectorAll('input, select, textarea')) {
      if (field.closest('form[data-uploadery]')) continue;
      if (field.getAttribute('form') !== flow.dataset.formId) field.setAttribute('form', flow.dataset.formId);
    }
    labelField(container, 'Bil / MC Mærke', config.brand_label, config.brand_placeholder, 1);
    labelField(container, 'Anden ønsker', config.wishes_label, config.wishes_placeholder, 2);
    const wishes = wishesState(flow, state);
    labelField(container, 'Instruction', wishes.required ? config.wishes_required_label : config.wishes_label, config.wishes_placeholder, 2);
    const select = container.querySelector('select[name="properties[Personalisering]"]');
    if (select) {
      let selectRow = select;
      while (selectRow.parentElement !== container && selectRow.parentElement) selectRow = selectRow.parentElement;
      selectRow.classList.add('bmp-order-select');
      const label = Array.from(container.querySelectorAll('label')).find((node) => node.htmlFor === select.id);
      if (label && !label.contains(select)) setText(label, config.standard_disclosure);
      for (const option of select.options) {
        if (option.value === 'JA') setText(option, config.standard_yes);
        else if (option.value === 'INGEN (venligst som vist på billedet)') setText(option, config.standard_no);
      }
      const enabled = select.value === 'JA';
      const details = flow.querySelector('[data-bmp-optional]');
      if (enabled && details) details.open = true;
      const terms = flow.querySelector('[data-bmp-order-terms]');
      if (terms) terms.hidden = !enabled;
    }
    const photos = Array.from(flow.querySelectorAll('[data-bmp-photo-choice]'));
    const photo = photos[0];
    for (const duplicate of photos.slice(1)) duplicate.remove();
    const uploadForm = container.querySelector('form[data-uploadery]');
    const uploadLabel = uploadForm?.querySelector('label');
    if (uploadLabel) {
      const textNodes = Array.from(uploadLabel.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE);
      if (textNodes[0] && textNodes[0].textContent !== config.photo_label) textNodes[0].textContent = config.photo_label;
      else if (!textNodes.length) uploadLabel.prepend(document.createTextNode(config.photo_label));
      for (const duplicate of textNodes.slice(1)) if (duplicate.textContent.trim()) duplicate.textContent = '';
    }
    if (!photo || !uploadForm) return;
    let uploadRow = uploadForm;
    while (uploadRow.parentElement !== container && uploadRow.parentElement) uploadRow = uploadRow.parentElement;
    if (photo.nextElementSibling !== uploadRow) uploadRow.before(photo);
    photo.hidden = false;
    photo.disabled = false;
    const status = uploadState(flow, state);
    for (const radio of photo.querySelectorAll('[data-bmp-photo-mode]')) radio.checked = radio.dataset.bmpPhotoMode === state.mode;
    uploadRow.hidden = state.mode === 'later' && !status.uploaded && !status.pending && !status.file?.files?.length;
    for (const hint of photo.querySelectorAll('[data-bmp-photo-hint]')) hint.hidden = hint.dataset.bmpPhotoHint !== state.mode || !!status.uploaded;
    const message = photo.querySelector('[data-bmp-photo-status]');
    setText(message, status.pending ? config.photo_uploading : status.uploaded ? (state.mode === 'later' ? config.photo_kept : config.photo_added) : '');
    message.hidden = !message.textContent;
    const radio = photo.querySelector('[data-bmp-photo-mode="later"]');
    const laterValue = status.uploaded ? config.photo_kept : config.photo_later;
    if (radio.value !== laterValue) radio.value = laterValue;
  }

  function positionInfiniteOptions() {
    frameId = 0;
    const targets = Array.from(document.querySelectorAll('[data-bmp-infinite-options-target]'));
    for (const target of targets) {
      const flow = target.closest('[data-bmp-order-flow]');
      if (!flow) {
        const container = document.querySelector('#infiniteoptions-container');
        if (container && container.nextElementSibling !== target) target.before(container);
        continue;
      }
      const state = getState(flow);
      const form = document.getElementById(flow.dataset.formId);
      const current = form?.querySelector('#infiniteoptions-container') || document.querySelector('#infiniteoptions-container');
      if (!state.container || state.container.isConnected) {
        if (current && (!current.dataset.bmpOrderProduct || current.dataset.bmpOrderProduct === flow.dataset.productId) &&
          (!current.dataset.bmpOrderForm || current.dataset.bmpOrderForm === flow.dataset.formId)) state.container = current;
      }
      if (!state.container) continue;
      state.container.dataset.bmpOrderProduct = flow.dataset.productId;
      state.container.dataset.bmpOrderForm = flow.dataset.formId;
      if (state.container.nextElementSibling !== target) target.before(state.container);
      enhance(flow, state);
    }
  }

  function schedulePosition() {
    if (!frameId) frameId = requestAnimationFrame(positionInfiniteOptions);
  }

  function validate(flow, event) {
    if (!flow) return;
    const state = getState(flow);
    const waitingForFields = !state.container && flow.dataset.personal === 'true';
    if (!state.container && !waitingForFields) return;
    const status = uploadState(flow, state);
    const requiresPhoto = flow.dataset.personal === 'true' && state.mode === 'now' && !status.uploaded;
    const wishes = wishesState(flow, state);
    const wishesBlocked = wishes.missing || !wishes.ready;
    if (!status.pending && !requiresPhoto && !wishesBlocked && !waitingForFields) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (waitingForFields) flow.hidden = false;
    const error = flow.querySelector('[data-bmp-photo-error]');
    if (error) {
      const key = waitingForFields ? 'wishes_loading' : wishes.missing ? 'wishes_required_error' : !wishes.ready ? 'wishes_loading' : status.pending ? 'photo_pending' : 'photo_required';
      setText(error, getConfig(flow)[key]);
      error.hidden = false;
      error.focus({ preventScroll: true });
    }
    const optional = flow.querySelector('[data-bmp-optional]');
    if (optional) optional.open = true;
    const accordion = flow.closest('details.details');
    if (accordion) accordion.open = true;
    if (wishes.missing && wishes.field) {
      wishes.field.setAttribute('aria-invalid', 'true');
      if (!wishes.field.disabled) wishes.field.focus({ preventScroll: true });
    }
    flow.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  window.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[ref="addToCartButton"], .sticky-add-to-cart__button');
    if (!button) return;
    let flow = button.closest('product-form-component')?.querySelector('[data-bmp-order-flow]');
    if (!flow) {
      const form = button.closest('product-form-component')?.querySelector('form[action*="/cart/add"]');
      flow = Array.from(button.closest('.shopify-section')?.querySelectorAll('[data-bmp-order-flow]') || [])
        .find((candidate) => candidate.dataset.formId === form?.id);
    }
    const sticky = button.closest('sticky-add-to-cart');
    if (!flow && sticky) {
      flow = Array.from(sticky.closest('.shopify-section')?.querySelectorAll('[data-bmp-order-flow]') || [])
        .find((candidate) => candidate.dataset.productId === sticky.dataset.productId);
    }
    validate(flow, event);
  }, true);

  window.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement && event.target.matches('form[action*="/cart/add"]')) validate(event.target.querySelector('[data-bmp-order-flow]') || Array.from(document.querySelectorAll('[data-bmp-order-flow]')).find((flow) => flow.dataset.formId === event.target.id), event);
  }, true);

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;
    const flow = event.target.closest('[data-bmp-order-flow]');
    if (!flow) return;
    const state = getState(flow);
    if (event.target.matches('[data-bmp-photo-mode]')) state.mode = event.target.dataset.bmpPhotoMode;
    if (event.target.matches('form[data-uploadery] input[type="file"]')) state.pending = !!event.target.files?.length;
    wishesState(flow, state);
    const error = flow.querySelector('[data-bmp-photo-error]');
    if (error) error.hidden = true;
    schedulePosition();
  }, true);

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof HTMLTextAreaElement)) return;
    const flow = event.target.closest('[data-bmp-order-flow]');
    if (!flow) return;
    const wishes = wishesState(flow, getState(flow));
    if (event.target !== wishes.field) return;
    const error = flow.querySelector('[data-bmp-photo-error]');
    if (error) error.hidden = true;
  }, true);

  document.addEventListener('uploadSuccess', (event) => {
    const flow = event.target.closest?.('[data-bmp-order-flow]');
    if (!flow || !event.detail?.file) return;
    getState(flow).pending = false;
    const error = flow.querySelector('[data-bmp-photo-error]');
    if (error) error.hidden = true;
    schedulePosition();
  });

  const observer = new MutationObserver(schedulePosition);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-uploadery-valid', 'disabled', 'name', 'name-disabled'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedulePosition, { once: true });
  else schedulePosition();
  document.addEventListener('shopify:section:load', schedulePosition);
})();
